import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";
import {
  selectDgSavedIds,
  selectFormAppData,
  selectFormConfig,
  selectFormData,
} from "../../../selectors";

const useGetFormStateValues = () => {
  const { isDialogForm } = useFormContext();

  const formData = useSelector((state) => selectFormData(state, isDialogForm));
  const dgSavedIds = useSelector((state) =>
    selectDgSavedIds(state, isDialogForm)
  );
  const formConfig = useSelector((state) =>
    selectFormConfig(state, isDialogForm)
  );
  const applicationData = useSelector((state) =>
    selectFormAppData(state, isDialogForm)
  );

  return {
    formData,
    formConfig,
    applicationData,
    dgSavedIds: dgSavedIds || [],
  };
};

export default useGetFormStateValues;
